module.exports = __webpack_public_path__ + "static/media/constructions.42171f1f.geojson";